import React from "react";
import "./ModalButtonLoader.css";

const ModalButtonLoader = () => {
  return (
    <div className="modal-dots">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default ModalButtonLoader;
